export default "__VITE_ASSET__DBkImtCF__"